import { Box, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ToolCartStyled = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.grey[400]};
  width: 400px;
`;

export const ToolCartListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: 50%;
  overflow-y: auto;
`;

export const CartHeaderStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  background-color: ${({ theme }) => theme.colors.orange[100]};
`;

export const ToolCountStyled = styled(Box)`
  display: inline-block;
  ${({ theme }) => css`
    height: 20px;
    width: 20px;
    border-radius: ${theme.radii[900]};
    background-color: ${theme.colors.bechtel.red};
    text-align: center;
  `}
`;

export const EditNonCatalogButtonStyled = styled(Button)`
  ${({ theme }) => css`
    height: 18px;
    width: 65px;
    border-radius: ${theme.radii[400]};
  `}
`;
